import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapsible } from 'radix-ui';
import React, { useState } from 'react';
import ProviderMatchItem from '~/components/Tools/CalculateMaximumMortgage/ProviderMatchItem';
import { useCalculateMaximumMortgageCalculation } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/CalculationContext';

const ProviderMatches: React.FC = () => {
  const VISIBLE_MATCHES = 6;

  const { providerMatches, selected, handleSelect } =
    useCalculateMaximumMortgageCalculation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (!providerMatches?.length) return null;

  const visibleMatches = providerMatches.slice(0, VISIBLE_MATCHES);
  const hiddenMatches = providerMatches.slice(VISIBLE_MATCHES);
  const hasHiddenMatches = hiddenMatches.length > 0;

  return (
    <div className="relative">
      <h2 className="relative z-20 mb-4 font-display text-2xl text-black">
        Aanbieders op Advieskeuze
      </h2>

      <Collapsible.Root open={isOpen} onOpenChange={setIsOpen}>
        <div className="space-y-2">
          {visibleMatches.map((match, index) => (
            <ProviderMatchItem
              key={`match-desktop-${index}`}
              {...match}
              selectedSlug={selected?.slug}
              onHandleSelect={handleSelect}
              isBestDeal={index === 0}
            />
          ))}

          {hasHiddenMatches && (
            <Collapsible.Content className="space-y-2">
              {hiddenMatches.map((match, index) => (
                <ProviderMatchItem
                  key={`match-desktop-${index + VISIBLE_MATCHES}`}
                  {...match}
                  selectedSlug={selected?.slug}
                  onHandleSelect={handleSelect}
                  isBestDeal={false}
                />
              ))}
            </Collapsible.Content>
          )}
        </div>

        {hasHiddenMatches && (
          <Collapsible.Trigger asChild>
            <button
              type="button"
              className="mt-4 flex w-full items-center gap-2 font-display text-sm font-bold text-blue-600 transition-colors hover:text-blue-800"
            >
              {isOpen ? (
                <>
                  <span>Toon minder aanbieders</span>
                  <FontAwesomeIcon icon={faChevronUp} />
                </>
              ) : (
                <>
                  <span>Toon alle {providerMatches.length} aanbieders</span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </>
              )}
            </button>
          </Collapsible.Trigger>
        )}
      </Collapsible.Root>
    </div>
  );
};

export default ProviderMatches;
